<template>
  <div class="vipLise-item">
    <div
      class="avatar"
      :style="{
        backgroundImage: `url(${
          item.headPictureUrl ? item.headPictureUrl : defaultImg
        })`,
      }"
    ></div>
    <div class="info">
      <div class="top">{{ item.nickName ? item.nickName : "暂无" }}</div>
      <div class="center">
        <div class="left">
          <van-tag
            class="tag"
            round
            v-if="item.isRegistered == 'T'"
            type="primary"
            >注册</van-tag
          >
          <van-tag class="tag" round v-if="item.isDeal == 'T'" type="primary"
            >成交</van-tag
          >
          <van-tag
            class="tag"
            round
            v-if="item.isHoldCard == 'T'"
            type="primary"
            >卡</van-tag
          >
        </div>
        <div class="right" @click="toNewPage">
          <span>{{ item.visitsNumber ? item.visitsNumber : 0 }} 次</span>
          <van-icon class="icon" name="arrow" />
        </div>
      </div>
      <div class="bottom">{{ item.mobile }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultImg: "https://img01.yzcdn.cn/vant/cat.jpeg",
    };
  },
  methods: {
    toNewPage() {
      this.$router.push({
        name: "MemberDetail",
        query: {
          memberId: this.item.memberId.toString(),
          isVisitor: "T",
          createTime: this.item.createTime,
          mobile: this.item.mobile,
          nickName: this.item.nickName,
          headPictureUrl: this.item.headPictureUrl,
        },
      });
    },
  },
};
</script>

<style lang="less" scope>
.vipLise-item {
  padding: 8px 0;
  display: flex;
  position: relative;

  .avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    margin-right: 10px;
    background-size: cover;
  }
  .info {
    height: 56px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
    .top {
      color: rgba(16, 16, 16, 100);
      font-size: 16px;
      font-family: PingFangSC-regular;
    }
    .center {
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        height: 100%;
        display: flex;
        .tag {
          margin-right: 4px;
        }
      }
      .right {
        height: 100%;
        color: rgba(16, 16, 16, 100);
        font-size: 12px;
        font-family: PingFangSC-regular;
        display: flex;
        align-items: center;
        .icon {
          margin-left: 8px;
        }
      }
    }
    .bottom {
      color: rgba(16, 16, 16, 100);
      font-size: 12px;
      font-family: PingFangSC-regular;
      opacity: 0.42;
    }
  }
}
</style>